import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

// Bootstrap's JS (dropdowns, modals, navbar collapse, carousels).
//
// NOTE: public/js/vendors.js (the original build's raw "chunk-vendors" file)
// is NOT used here — it's a webpack chunk that depends on that build's own
// module-loading runtime, which doesn't exist in this project, so loading it
// standalone does nothing (that's why modals/carousels weren't popping up).
// The real npm "bootstrap" package below is what actually wires up
// data-bs-toggle="modal" / data-bs-slide etc.
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/css/app.css";

createApp(App).use(router).mount("#app");
